import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { Swiper } from 'swiper'

gsap.registerPlugin(ScrollTrigger)

const alkoTab = $('[data-alko-tab]')
const alkoTabContent = $('[data-alko-content-tab]')

$('body').on('click', '[data-alko-tab]', function (e){
  e.preventDefault()
  const activeTab = $(this).attr('data-alko-tab')
  alkoTab.removeClass('is-active')
  alkoTabContent.removeClass('is-active')
  $(this).addClass('is-active')
  $('[data-alko-content-tab="'+activeTab+'"]').addClass('is-active')

  ScrollTrigger.refresh()

  gsap.fromTo('.alcohol-list .alcohol-list-row', { opacity: 0 }, { opacity: 1, duration: 1.5 })

})

// .slider-alcohol-block-navigation
if($('.slider-alcohol-block-navigation').length) {

  $(window).on('load', function (e){
    new Swiper(".slider-alcohol-block-navigation", {
      slidesPerView: "auto",
      spaceBetween: 2,
      freeMode: true,
    });
  })

}
